<form [formGroup]="formPaymentInfo">
  <div class="ui-g readonlytbox">
    <div class="ui-g-12 ui-md-8 ui-lg-8">
      <div class="ui-g">
        <div class="ui-g-12 ui-md-6 ui-lg-6">Pre-Sales Activity Date</div>
        <div class="ui-g-12 ui-md-6 ui-lg-6">
          <input
            type="text"
            pInputText
            readonly
            formControlName="preSaleActivityDate" />
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-6 ui-lg-6">
          Partner Payment Profile Status
        </div>

        <div class="ui-g-12 ui-md-6 ui-lg-6">
          <p-radioButton
            name="ppS1"
            [disabled]="true"
            value="true"
            formControlName="partnerPaymentProfileStatus"
            inputId="ppS"></p-radioButton
          ><label for="ppS" class="ml-2">Yes</label>
          <p-radioButton
            name="ppS1"
            class="ml-4"
            [disabled]="true"
            value="false"
            formControlName="partnerPaymentProfileStatus"
            inputId="ppS"></p-radioButton
          ><label for="ppS" class="ml-2">No</label>
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-6 ui-lg-6">Supplier ID</div>
        <div class="ui-g-12 ui-md-6 ui-lg-6">
          <input type="text" pInputText readonly formControlName="supplierID" />
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-6 ui-lg-6">Payee ID</div>
        <div class="ui-g-12 ui-md-6 ui-lg-6">
          <input type="text" pInputText readonly formControlName="payeeID" />
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-6 ui-lg-6">Payee Name</div>
        <div class="ui-g-12 ui-md-6 ui-lg-6">
          <input type="text" pInputText readonly formControlName="payeeName" />
        </div>
      </div>
      <div class="ui-g">
        <div
          class="ui-xl-6 ui-g-12 ui-md-6 ui-lg-6 align-activity pl-0 pr-0 mb-1">
          <span class="activity-font font-bold payment-title align pr-2"
            >Agreement</span
          >
        </div>
        <div class="ui-g-12 ui-md-6 ui-lg-6">
          <p-radioButton
            name="agre1"
            [disabled]="true"
            value="true"
            formControlName="agreement"
            inputId="agre"></p-radioButton>
          <label for="agre" class="ml-2">Yes</label>
          <p-radioButton
            name="agre1"
            class="ml-4"
            [disabled]="true"
            value="false"
            formControlName="agreement"
            inputId="agre"></p-radioButton
          ><label for="agre" class="ml-2">No</label>
        </div>
      </div>
    </div>
  </div>
</form>
